
export default {
  head() {
    return {
      title: "Agence Google Ads | SEA à Dijon dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads à Dijon certifiée Google Partner, accompagne les entreprises dijonnaises pour booster leur visibilité et acquérir plus de clients.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Agence Google Ads à Dijon dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads à Dijon certifiée Google Partner, accompagne les entreprises dijonnaises pour booster leur visibilité et acquérir plus de clients.",
        },
      ],
    };
  },
};
